import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import actions from 'actions';
import Barometre from 'components/Barometre';
import { Footer } from '@ma-react/components';
import Header from 'components/Header';
import { DEBOUNCE_TIMEOUT, LOGIN_INPUT_PREFIX } from 'constants/Global';
import { hasPhoneRetrieval } from 'helpers/FormInformations';
import { deepEqual } from 'helpers/ObjectUtils';
import { GA_PAGE_CATEGORY } from 'constants/Global';
import { getSearchParamsAsObject } from 'helpers/Referrer';

/**
 * Select props from Redux state.
 * @param {Object} state Current state
 */
const mapStateToProps = (state) => ({
    auth: state.auth,
    pending: state.pending[actions.GET_ESTIMA] || state.pending[actions.CREATE_ESTIMA],
    error: state.error,
    step: state.steps,
});

/**
 * Provide dispatch functions in props.
 * @param {Function} dispatch Redux dispatch function
 */
const mapDispatchToProps = (dispatch, ownProps) => ({
    goToStepsForm: () => dispatch(actions.goToStepsForm(ownProps.values)),
    onErrorDiscard: () => dispatch(actions.clearError()),
    gaBarometreRetrievePhoneStep: () => dispatch(actions.gaBarometreRetrievePhoneStep()),
});

/**
 * Barometre Component.
 */
export class BarometreFormComponent extends Component {
    /**
     * Creates an instance of BarometreFormComponent.
     * @param {Object} props Props of component
     */
    constructor(props) {
        super(props);

        this.state = {
            isPhoneStep: false,
        };

        this.setPhoneStep = this.setPhoneStep.bind(this);
    }

    /**
     * React lifecycle.
     */
    componentDidMount() {
        this.props.changeStep(0);
    }

    /**
     * React lifecycle.
     * Triggers async validation when form values change.
     * @param {Object} prevProps prevProps
     */
    componentDidUpdate(prevProps) {
        const { asyncValidate, auth, change, values } = this.props;

        if (!deepEqual(prevProps.values, values) || !deepEqual(prevProps.auth, auth)) {
            const withPhoneRetrieval = hasPhoneRetrieval(this.props);

            if (!withPhoneRetrieval || !this.state.isPhoneStep) {
                clearTimeout(this.asyncValidationTimeout);

                /**
                 * Debounce timeout identifier.
                 */
                this.asyncValidationTimeout = setTimeout(() => asyncValidate(), DEBOUNCE_TIMEOUT);
            }

            if (withPhoneRetrieval && values[`${LOGIN_INPUT_PREFIX}action`] !== 'update') {
                change(`${LOGIN_INPUT_PREFIX}action`, 'update');
            } else if (!withPhoneRetrieval && values[`${LOGIN_INPUT_PREFIX}action`] === 'update') {
                change(`${LOGIN_INPUT_PREFIX}action`, '');
            }
        }
    }

    /**
     * Change Barometre step to retrieve phone or not and init tagging for retrieve phone step when needed
     * @param {Boolean} isPhoneStep is in retrieve phone step or not
     */
    // eslint-disable-next-line no-undef
    setPhoneStep(isPhoneStep) {
        if (isPhoneStep) {
            this.props.gaBarometreRetrievePhoneStep();
        }

        this.setState({ isPhoneStep });
    }

    /**
     * React lifecycle.
     */
    render() {
        const { pending, values, submit, goToStepsForm, step, error, onErrorDiscard } = this.props;
        const { token } = getSearchParamsAsObject();
        const withPhoneRetrieval = hasPhoneRetrieval(this.props) && !token;

        return (
            <>
                <Header data-testid="barometre-header" />
                <Barometre
                    data-testid="barometre"
                    pending={pending}
                    estima={values}
                    submit={submit}
                    goToStepsForm={goToStepsForm}
                    formValid={step.valid}
                    error={error}
                    onErrorDiscard={onErrorDiscard}
                    withPhoneRetrieval={withPhoneRetrieval}
                    isPhoneStep={this.state.isPhoneStep}
                    setPhoneStep={this.setPhoneStep}
                />
                <Footer
                    data-testid="barometre-footer"
                    className="hide-sm"
                    basename=""
                    pageCategory={GA_PAGE_CATEGORY}
                    proUrl={MA.Config.PRO_URL}
                />
            </>
        );
    }
}

BarometreFormComponent.propTypes = {
    asyncValidate: PropTypes.func,
    auth: PropTypes.shape({}),
    changeStep: PropTypes.func.isRequired,
    pending: PropTypes.bool,
    submit: PropTypes.func,
    values: PropTypes.shape({}),
};

/**
 * BarometreFormComponent connected.
 */
export default connect(mapStateToProps, mapDispatchToProps)(BarometreFormComponent);
